var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _ellipse, _path13, _rect, _rect2, _rect3, _rect4, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSelfie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 76,
    viewBox: "0 0 63 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53024 32.4978L10.9559 35.0274L5.61914 37.4539L11.0907 42.1564L5.95219 43.1872L10.9797 47.8183C10.9797 47.8183 7.71262 49.9038 8.16463 50.0862C8.61663 50.2686 13.66 54.5904 13.66 54.5904L13.1129 31.6493L7.53024 32.4978Z",
    fill: "#BEE3EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5597 54.2653C47.5122 57.7386 40.9224 64.2252 35.1019 65.2006C29.2814 66.1759 11.7009 54.5825 12.034 52.4018C12.367 50.2211 21.4071 32.252 26.0222 33.2274C30.6374 34.2027 47.639 48.4289 47.5597 54.2653Z",
    fill: "#BEE3EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6746 51.2885H35.2422L35.2422 10.5924H11.6746L11.6746 51.2885Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1465 12.3798V53.8846C10.1465 55.0265 11.0267 55.9543 12.1131 55.9543H34.7687C35.8551 55.9543 36.7353 55.0265 36.7353 53.8846V12.3798C36.7353 11.2379 35.8551 10.3101 34.7687 10.3101H12.1052C11.0188 10.3101 10.1465 11.2379 10.1465 12.3798ZM12.1369 12.9904H34.737L34.7687 48.8695H12.1686L12.1369 12.9904Z",
    fill: "#7EBED0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36902 27.5257C8.74965 27.4781 10.9224 28.2553 10.9542 30.3646C10.9859 32.466 9.07477 33.037 8.36902 33.0449C7.65533 33.0449 6.81476 31.6651 6.76718 30.2853C6.72753 28.961 7.44915 27.6367 8.36902 27.5257Z",
    fill: "#D2EEF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48935 28.0491C7.66381 28.0333 7.22767 29.0324 7.24353 30.2854C7.25939 31.2528 7.71932 32.4343 7.529 32.4978C7.21974 32.5929 6.625 31.4907 6.625 30.2854C6.625 29.08 7.14044 28.0809 7.48935 28.0491Z",
    fill: "#EBFAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44101 33.4256C8.82164 33.3781 10.9944 34.1552 11.0261 36.2645C11.0579 38.3659 9.14676 38.9369 8.44101 38.9448C7.72732 38.9448 5.30078 38.2946 5.30078 36.3438C5.30078 34.5437 7.52114 33.5366 8.44101 33.4256Z",
    fill: "#D2EEF7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56092 33.949C7.73538 33.9332 7.29924 34.9323 7.3151 36.1853C7.33096 37.1527 7.79089 38.3342 7.60057 38.3977C7.29131 38.4928 6.34766 37.3827 6.34766 36.1773C6.34766 34.9641 7.21201 33.9728 7.56092 33.949Z",
    fill: "#EBFAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65628 39.4761C9.01312 39.4365 11.067 40.166 11.0987 42.1564C11.1304 44.1468 9.32239 44.6861 8.65628 44.6861C7.98224 44.6861 5.61914 43.9089 5.61914 42.0771C5.61914 40.3008 7.78399 39.5792 8.65628 39.4761Z",
    fill: "#D2EEF7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81475 39.9677C7.97334 39.9519 7.56892 40.8955 7.58478 42.0771C7.60064 42.9969 8.03678 44.1071 7.8544 44.1626C7.56892 44.2578 6.87109 43.2031 6.87109 42.0691C6.87109 40.9352 7.48962 39.9915 7.81475 39.9677Z",
    fill: "#EBFAFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61461 45.2174C8.96352 45.1777 10.946 45.8914 10.9777 47.8104C11.0094 49.7374 9.25693 50.2608 8.61461 50.2608C7.95643 50.2608 7.18723 48.9999 7.14758 47.7391C7.11586 46.5258 7.77404 45.3205 8.61461 45.2174Z",
    fill: "#D2EEF7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80654 45.701C7.96514 45.6851 7.56864 46.5971 7.5845 47.739C7.60036 48.6271 8.02065 49.7056 7.84619 49.7611C7.56864 49.8483 7.02148 48.8412 7.02148 47.739C7.02148 46.6367 7.48935 45.7248 7.80654 45.701Z",
    fill: "#EBFAFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5522 49.8563L62.9996 64.0111L40.4946 75.1764C40.4946 75.1764 34.8644 66.3266 33.5164 65.2006C32.1762 64.0746 47.5522 49.8563 47.5522 49.8563Z",
    fill: "#D2EEF7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4942 75.1763C40.4942 75.1763 34.3803 66.3345 33.952 65.7635C33.5238 65.1926 31.5176 64.7802 31.5176 64.7802L39.4236 57.7068L44.1736 57.1041C44.1736 57.1041 41.303 58.6425 39.7726 61.1246C38.2421 63.6066 41.0493 67.8491 42.8176 72.1074",
    fill: "#BEE3EF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.3768,
    cy: 25.8917,
    rx: 5.46667,
    ry: 5.31264,
    fill: "#9FD9EA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5652 42.6468C35.5697 42.5292 35.572 42.4112 35.572 42.2927C35.572 36.6201 30.3276 32.0216 23.8583 32.0216C17.3889 32.0216 12.1445 36.6201 12.1445 42.2927C12.1445 42.4112 12.1468 42.5292 12.1514 42.6468H35.5652ZM23.9098 52.5637H23.8067C23.8239 52.5638 23.8411 52.5638 23.8583 52.5638C23.8754 52.5638 23.8926 52.5638 23.9098 52.5637Z",
    fill: "#9FD9EA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.62891,
    y: 10.6877,
    width: 5.76589,
    height: 1.44147,
    rx: 0.720736,
    transform: "rotate(-136.086 9.62891 10.6877)",
    fill: "#7EBED0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1465,
    y: 9.11072,
    width: 5.76589,
    height: 1.44147,
    rx: 0.720736,
    transform: "rotate(-91.0856 12.1465 9.11072)",
    fill: "#7EBED0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.99609,
    y: 13.4231,
    width: 5.76589,
    height: 1.44147,
    rx: 0.720736,
    transform: "rotate(178.914 8.99609 13.4231)",
    fill: "#7EBED0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1445,
    y: 42.0919,
    width: 22.5086,
    height: 7.2165,
    fill: "#9FD9EA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6812 33.7031C25.6407 33.3938 28.4003 32.3471 29.2646 32.3709C30.4938 32.4026 40.2158 34.7736 40.9612 35.5508C41.7066 36.3279 47.7729 44.2181 47.5509 49.8562C47.3289 55.4944 43.7446 57.7068 42.4678 58.0081C41.1911 58.3095 36.3143 57.6116 34.8076 54.2414C33.1265 50.4906 34.5459 42.9652 34.1494 42.6956C31.0409 40.5148 30.1528 38.1993 29.677 38.35C29.2012 38.5007 26.1561 38.9685 24.245 38.2073C22.1357 37.3746 20.518 35.1622 21.1127 34.623C21.7075 34.0837 23.349 34.1313 24.6812 33.7031Z",
    fill: "#D2EEF7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1126 34.6231C21.3505 34.8689 21.8976 35.2971 23.0237 35.1782C24.1497 35.0592 25.8308 34.5041 25.8308 34.2028C25.8308 33.9014 25.2678 33.4891 25.0696 33.5763C24.8713 33.6635 20.8429 34.3455 21.1126 34.6231Z",
    fill: "#EBFAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSelfie);
export default __webpack_public_path__ + "static/media/img_selfie.a2dda88e105abb0c92529acbc6d5d876.svg";
export { ForwardRef as ReactComponent };